module.exports = __webpack_public_path__ + "assets/img/DS-kitchen (6).f694f267.jpg";